export const ANALYTICS_GRAPH_TYPES = {
  FUNNEL: 'funnel',
  FUNNEL_WATERFALL: 'funnel_waterfall',
  PIPELINE_FLOW: 'pipeline_flow',
  HORIZONTAL_BAR: 'horizontal_bar',
  SANKEY_FLOW: 'sankey_flow',
  LINE_OVER_TIME: 'line_over_time',
  AREA_CHART: 'area_chart',
  GROUPED_BAR: 'grouped_bar',
  STACKED_BAR: 'stacked_bar',
  STACKED_AREA: 'stacked_area',
  STACKED_HORIZONTAL_BAR: 'stacked_horizontal_bar',
  MULTI_LINE: 'multi_line',
  BAR_OVER_TIME: 'bar_over_time',
  SCATTER: 'scatter',
  BUBBLE_CHART: 'bubble_chart',
  RADAR: 'radar',
  DONUT: 'donut',
  HEATMAP: 'heatmap',
  TABLE: 'table',
  CONDITIONAL_TABLE: 'conditional_table',
  TREEMAP: 'treemap',
  KPI_CARD: 'kpi_card',
  OFFER_SIGNAL_CARD: 'offer_signal_card',
  SOURCE_RANKINGS: 'source_rankings',
  RECRUITER_CARDS: 'recruiter_cards',
  KPI_SPARKLINE: 'kpi_sparkline',
  GAUGE: 'gauge',
  GOAL_TRACK: 'goal_track',
  GOAL_LABEL_TREND: 'goal_label_trend',
  BULLET_CHART: 'bullet_chart',
  RADIAL_RINGS: 'radial_rings',
  PROGRESS_BARS: 'progress_bars',
  BOX_PLOT: 'box_plot',
  VIOLIN_PLOT: 'violin_plot',
  HISTOGRAM: 'histogram',
  WORLD_CHOROPLETH: 'world_choropleth',
  REGIONAL_MAP: 'regional_map',
  CITY_DOT_MAP: 'city_dot_map',
  GANTT_TIMELINE: 'gantt_timeline',
  STALLING_OFFERS: 'stalling_offers',
  RISK_ACTION_TABLE: 'risk_action_table',
  STACKED_BAR_LINE: 'stacked_bar_line',
  RETENTION_HEATMAP: 'retention_heatmap'
};

export const ANALYTICS_GRAPH_GROUPS = {
  FLOW: [
    ANALYTICS_GRAPH_TYPES.FUNNEL,
    ANALYTICS_GRAPH_TYPES.FUNNEL_WATERFALL,
    ANALYTICS_GRAPH_TYPES.PIPELINE_FLOW,
    ANALYTICS_GRAPH_TYPES.SANKEY_FLOW
  ],
  BAR: [
    ANALYTICS_GRAPH_TYPES.HORIZONTAL_BAR,
    ANALYTICS_GRAPH_TYPES.GROUPED_BAR,
    ANALYTICS_GRAPH_TYPES.STACKED_BAR,
    ANALYTICS_GRAPH_TYPES.STACKED_HORIZONTAL_BAR,
    ANALYTICS_GRAPH_TYPES.BAR_OVER_TIME,
    ANALYTICS_GRAPH_TYPES.PROGRESS_BARS,
    ANALYTICS_GRAPH_TYPES.BULLET_CHART,
    ANALYTICS_GRAPH_TYPES.STACKED_BAR_LINE
  ],
  TIME_SERIES: [
    ANALYTICS_GRAPH_TYPES.LINE_OVER_TIME,
    ANALYTICS_GRAPH_TYPES.MULTI_LINE,
    ANALYTICS_GRAPH_TYPES.AREA_CHART,
    ANALYTICS_GRAPH_TYPES.STACKED_AREA
  ],
  DISTRIBUTION: [
    ANALYTICS_GRAPH_TYPES.BOX_PLOT,
    ANALYTICS_GRAPH_TYPES.VIOLIN_PLOT,
    ANALYTICS_GRAPH_TYPES.HISTOGRAM,
    ANALYTICS_GRAPH_TYPES.SCATTER,
    ANALYTICS_GRAPH_TYPES.BUBBLE_CHART
  ],
  PROFILE: [ANALYTICS_GRAPH_TYPES.RADAR],
  SUMMARY: [
    ANALYTICS_GRAPH_TYPES.KPI_CARD,
    ANALYTICS_GRAPH_TYPES.OFFER_SIGNAL_CARD,
    ANALYTICS_GRAPH_TYPES.SOURCE_RANKINGS,
    ANALYTICS_GRAPH_TYPES.RECRUITER_CARDS,
    ANALYTICS_GRAPH_TYPES.KPI_SPARKLINE,
    ANALYTICS_GRAPH_TYPES.GAUGE,
    ANALYTICS_GRAPH_TYPES.RADIAL_RINGS
  ],
  GOAL: [
    ANALYTICS_GRAPH_TYPES.GOAL_TRACK,
    ANALYTICS_GRAPH_TYPES.GOAL_LABEL_TREND
  ],
  MATRIX: [
    ANALYTICS_GRAPH_TYPES.HEATMAP,
    ANALYTICS_GRAPH_TYPES.TABLE,
    ANALYTICS_GRAPH_TYPES.CONDITIONAL_TABLE,
    ANALYTICS_GRAPH_TYPES.TREEMAP,
    ANALYTICS_GRAPH_TYPES.RETENTION_HEATMAP
  ],
  GEOGRAPHY: [
    ANALYTICS_GRAPH_TYPES.WORLD_CHOROPLETH,
    ANALYTICS_GRAPH_TYPES.REGIONAL_MAP,
    ANALYTICS_GRAPH_TYPES.CITY_DOT_MAP
  ],
  PART_TO_WHOLE: [ANALYTICS_GRAPH_TYPES.DONUT],
  OPERATIONS: [
    ANALYTICS_GRAPH_TYPES.GANTT_TIMELINE,
    ANALYTICS_GRAPH_TYPES.STALLING_OFFERS,
    ANALYTICS_GRAPH_TYPES.RISK_ACTION_TABLE
  ]
};

export const getAnalyticsGraphsByGroup = (group) => ANALYTICS_GRAPH_GROUPS[group] || [];

export const ANALYTICS_GRAPH_METADATA = {
  [ANALYTICS_GRAPH_TYPES.FUNNEL]: { purpose: 'flow_snapshot', temporal: false },
  [ANALYTICS_GRAPH_TYPES.FUNNEL_WATERFALL]: { purpose: 'flow_snapshot', temporal: false },
  [ANALYTICS_GRAPH_TYPES.PIPELINE_FLOW]: { purpose: 'flow_exit_diagnostics', temporal: false },
  [ANALYTICS_GRAPH_TYPES.SANKEY_FLOW]: { purpose: 'flow_exit_diagnostics', temporal: false },
  [ANALYTICS_GRAPH_TYPES.HORIZONTAL_BAR]: { purpose: 'ranked_comparison', temporal: false },
  [ANALYTICS_GRAPH_TYPES.GROUPED_BAR]: { purpose: 'side_by_side_comparison', temporal: false },
  [ANALYTICS_GRAPH_TYPES.STACKED_BAR]: { purpose: 'composition_by_segment', temporal: false },
  [ANALYTICS_GRAPH_TYPES.STACKED_HORIZONTAL_BAR]: { purpose: 'share_of_total_breakdown', temporal: false },
  [ANALYTICS_GRAPH_TYPES.LINE_OVER_TIME]: { purpose: 'trend', temporal: true },
  [ANALYTICS_GRAPH_TYPES.MULTI_LINE]: { purpose: 'multi_series_trend', temporal: true },
  [ANALYTICS_GRAPH_TYPES.AREA_CHART]: { purpose: 'trend', temporal: true },
  [ANALYTICS_GRAPH_TYPES.STACKED_AREA]: { purpose: 'trend_composition', temporal: true },
  [ANALYTICS_GRAPH_TYPES.BAR_OVER_TIME]: { purpose: 'periodic_trend', temporal: true },
  [ANALYTICS_GRAPH_TYPES.SCATTER]: { purpose: 'relationship', temporal: false },
  [ANALYTICS_GRAPH_TYPES.BUBBLE_CHART]: { purpose: 'relationship_with_scale', temporal: false },
  [ANALYTICS_GRAPH_TYPES.RADAR]: { purpose: 'profile_comparison', temporal: false },
  [ANALYTICS_GRAPH_TYPES.HEATMAP]: { purpose: 'matrix_intensity', temporal: false },
  [ANALYTICS_GRAPH_TYPES.TABLE]: { purpose: 'tabular', temporal: false },
  [ANALYTICS_GRAPH_TYPES.CONDITIONAL_TABLE]: { purpose: 'tabular_conditional', temporal: false },
  [ANALYTICS_GRAPH_TYPES.TREEMAP]: { purpose: 'part_to_whole', temporal: false },
  [ANALYTICS_GRAPH_TYPES.KPI_CARD]: { purpose: 'headline_metric', temporal: false },
  [ANALYTICS_GRAPH_TYPES.OFFER_SIGNAL_CARD]: { purpose: 'headline_metric_with_ranked_breakdown', temporal: false },
  [ANALYTICS_GRAPH_TYPES.SOURCE_RANKINGS]: { purpose: 'ranked_source_snapshot', temporal: false },
  [ANALYTICS_GRAPH_TYPES.RECRUITER_CARDS]: { purpose: 'profile_cards', temporal: false },
  [ANALYTICS_GRAPH_TYPES.KPI_SPARKLINE]: { purpose: 'headline_metric_with_trend', temporal: true },
  [ANALYTICS_GRAPH_TYPES.GAUGE]: { purpose: 'bounded_rate', temporal: false },
  [ANALYTICS_GRAPH_TYPES.GOAL_TRACK]: { purpose: 'target_vs_actual', temporal: false },
  [ANALYTICS_GRAPH_TYPES.GOAL_LABEL_TREND]: { purpose: 'goal_progress_trend', temporal: true },
  [ANALYTICS_GRAPH_TYPES.BULLET_CHART]: { purpose: 'target_vs_actual', temporal: false },
  [ANALYTICS_GRAPH_TYPES.RADIAL_RINGS]: { purpose: 'goal_progress', temporal: false },
  [ANALYTICS_GRAPH_TYPES.PROGRESS_BARS]: { purpose: 'goal_progress', temporal: false },
  [ANALYTICS_GRAPH_TYPES.BOX_PLOT]: { purpose: 'distribution', temporal: false },
  [ANALYTICS_GRAPH_TYPES.VIOLIN_PLOT]: { purpose: 'distribution', temporal: false },
  [ANALYTICS_GRAPH_TYPES.HISTOGRAM]: { purpose: 'distribution', temporal: false },
  [ANALYTICS_GRAPH_TYPES.WORLD_CHOROPLETH]: { purpose: 'geo_distribution', temporal: false },
  [ANALYTICS_GRAPH_TYPES.REGIONAL_MAP]: { purpose: 'geo_distribution', temporal: false },
  [ANALYTICS_GRAPH_TYPES.CITY_DOT_MAP]: { purpose: 'geo_distribution', temporal: false },
  [ANALYTICS_GRAPH_TYPES.GANTT_TIMELINE]: { purpose: 'forecast_timeline', temporal: true },
  [ANALYTICS_GRAPH_TYPES.STALLING_OFFERS]: { purpose: 'operational_stalls', temporal: false },
  [ANALYTICS_GRAPH_TYPES.RISK_ACTION_TABLE]: { purpose: 'ranked_actions', temporal: false },
  [ANALYTICS_GRAPH_TYPES.STACKED_BAR_LINE]: { purpose: 'cohort_composition_with_velocity', temporal: true },
  [ANALYTICS_GRAPH_TYPES.RETENTION_HEATMAP]: { purpose: 'cohort_retention_grid', temporal: true }
};
